<!-- 物理因素接触限值井下挖掘 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]" class="title">井下采掘工作场所气象条件</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="dryBulbTemperature" label="干球温度（℃）">
      </el-table-column>
      <el-table-column align="center" prop="relativeHumidity" label="相对湿度（％）">
      </el-table-column>
      <el-table-column align="center" prop="windSpeed" label="风速（v，m/s）">
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.findExcavation()
    },
    methods:{
      async findExcavation(){
        let res = await this.$axios.get(this.$serviceAPI.findExcavation)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/excavation.vue